import { render, staticRenderFns } from "./_WorldSubEnded.vue?vue&type=template&id=d794c034&scoped=true&"
import script from "./_WorldSubEnded.vue?vue&type=script&lang=js&"
export * from "./_WorldSubEnded.vue?vue&type=script&lang=js&"
import style0 from "./_WorldSubEnded.vue?vue&type=style&index=0&id=d794c034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d794c034",
  null
  
)

export default component.exports